import { DS } from '../PatientForms/designTokens';

export type ManageAction = 'booked' | 'handled';

// `notify` is the whole difference between the two actions: marking a patient
// as handled resolves them without contacting them, so it is kept next to the
// copy that promises the patient exactly that
export const MANAGE_ACTIONS: Record<
  ManageAction,
  {
    notify: boolean;
    titleKey: string;
    descriptionKey: string;
    noticeKey: string;
    noticeBackground: string;
    confirmKey: string;
    toastKey: string;
  }
> = {
  booked: {
    notify: true,
    titleKey: 'manageDialog.booked.title',
    descriptionKey: 'manageDialog.booked.description',
    noticeKey: 'manageDialog.booked.notice',
    noticeBackground: DS.coolMint,
    confirmKey: 'manageDialog.booked.confirmButton',
    toastKey: 'manageToast.booked',
  },
  handled: {
    notify: false,
    titleKey: 'manageDialog.handled.title',
    descriptionKey: 'manageDialog.handled.description',
    noticeKey: 'manageDialog.handled.notice',
    noticeBackground: DS.surfaceCanvas,
    confirmKey: 'manageDialog.handled.confirmButton',
    toastKey: 'manageToast.handled',
  },
};
